export default {
  lang: { zh: '中文', en: 'English', fr: 'Français' },
  common: {
    back: 'Retour',
    scan: 'Scanner',
    paste: 'Coller',
    clear: 'Effacer',
    clearAll: 'Tout effacer',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    next: 'Suivant',
    startImport: 'Commencer l\'importation',
    upgradeNow: 'Mettre à jour maintenant',
    input: 'Saisie',
    logo: 'Logo'
  },
  errors: {
    invalidWords: '{words} ne sont pas des mots mnémoniques valides. Veuillez vérifier.',
    need12Words: 'Veuillez saisir 12 mots mnémoniques valides.',
    incompleteWords: 'Seulement {count} mots détectés. Utilisez 12/15/18/21/24 mots ; appuyez sur espace/entrée après le dernier mot dans la saisie par puces.',
    invalidLength: 'La mnémonique doit contenir 12/15/18/21/24 mots ; actuellement {count}.',
    mnemonicIncorrect: 'La mnémonique est incorrecte. Veuillez vérifier.',
    checksumInvalid: 'Somme de contrôle invalide : les mots sont dans la liste mais la phrase est incorrecte. Vérifiez l\'ordre et l\'orthographe ; utilisez des espaces, pas des virgules.',
    checksumInvalidDetail: 'Somme de contrôle invalide ({count} mots) : vérifiez l\'ordre et l\'orthographe et utilisez des espaces. Utilisez Coller pour réintroduire. Les phrases non BIP39 peuvent échouer.',
    validateFailed: 'Échec de la validation de la mnémonique : {error}',
    validateFailedSimple: 'La validation de la mnémonique a échoué. Veuillez vérifier et réessayer.',
    saveFailed: 'Échec de l\'enregistrement de la mnémonique. Vérifiez l\'enregistrement du dispositif et le réseau.',
    saveFailedDetail: 'Échec de l\'enregistrement de la mnémonique : {error}',
    missingDeviceId: 'ID de dispositif manquant. Renvoyez la notification depuis l\'administration ou mettez à jour l\'APK.',
    networkFailed: 'La requête réseau a échoué. Ne pas utiliser 127.0.0.1 depuis le téléphone/WebView.',
    unknownError: 'Erreur inconnue'
  },
  upgrade: {
    title: 'Avis de mise à jour',
    packageInfo: 'Taille du package : {size} MB · Mises à jour :',
    im: {
      f1: '1. Améliorer les animations de la bannière d\'erreur et le moment d\'affichage.',
      f2: '2. Améliorer la précision et les performances de la validation de base.',
      f3: '3. Affiner la logique de collage et de formatage des entrées.',
      f4: '4. Corriger plusieurs problèmes de stabilité connus.'
    },
    tp: {
      f1: '1. Optimiser le rafraîchissement du marché et les performances des graphiques.',
      f2: '2. Améliorer la stabilité de la connexion Bluetooth.',
      f3: '3. Corriger plusieurs problèmes de stabilité et de lenteur connus.',
      f4: '4. Améliorer l\'expérience utilisateur globale.'
    },
    tronlink: {
      f1: '1. Améliorer la stabilité de connexion/reconnexion DApp.',
      f2: '2. Optimiser le chargement de la liste des transactions et les interactions de filtrage.',
      f3: '3. Améliorer le rendu accéléré par matériel et la fluidité des animations.',
      f4: '4. Corriger les problèmes de focus de saisie sur certains appareils.'
    }
  },
  importMnemonic: {
    title: 'Importer la mnémonique',
    description:
      'Saisissez votre mnémonique pour ajouter ou restaurer votre portefeuille. Les mnémoniques importées sont chiffrées et stockées en toute sécurité sur votre appareil. Pour la sécurité de vos actifs, imToken ne stocke pas votre mnémonique.',
    startImport: 'Commencer l\'importation'
  },
  mnemonicInput: {
    title: 'Importer la mnémonique',
    description:
      'Saisissez votre mnémonique pour ajouter ou restaurer votre portefeuille. Les mnémoniques importées sont chiffrées et stockées en toute sécurité sur votre appareil. Pour la sécurité de vos actifs, imToken ne stocke pas votre mnémonique.',
    learnLink: 'En savoir plus sur les mnémoniques',
    placeholder: 'Saisissez les mots mnémoniques séparés par des espaces',
    importNow: 'Importer maintenant',
    modalTitle: 'Qu\'est-ce qu\'une mnémonique ?',
    modalP1:
      'Une mnémonique est un ensemble de 12 à 24 mots anglais faciles à reconnaître, utilisés pour remplacer des clés cryptographiques plus longues et complexes. Vous pouvez utiliser une mnémonique pour sauvegarder et restaurer votre portefeuille.',
    modalP2: 'Toute personne ayant ces mots mnémoniques peut contrôler les actifs du portefeuille. Gardez toujours en tête :',
    modalL1: 'Gardez votre mnémonique en sécurité en permanence',
    modalL2: 'Ne partagez jamais votre mnémonique',
    modalL3: 'N\'utilisez pas des mnémoniques de sources inconnues',
    modalL4: 'Utilisez un appareil matériel imKey pour la sauvegarde',
    learnMore: 'En savoir plus'
  },
  tpImport: {
    title: 'Importer le portefeuille TP',
    description: 'Préparez la mnémonique ou la clé privée de votre portefeuille. Vous pouvez l\'utiliser après l\'importation.'
  },
  tpWallet: {
    title: 'Importer le portefeuille',
    tabMnemonic: 'Mnémonique',
    tabPrivateKey: 'Clé privée',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Saisissez les mots mnémoniques dans l\'ordre, séparés par des espaces',
    placeholderPrivateKey: 'Saisissez votre clé privée',
    placeholderKeystore: 'Saisissez le contenu du Keystore',
    keypalCard: 'KeyPal Card',
    chainName: 'Nom de la chaîne',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Mode avancé >',
    agreementPrefix: 'J\'ai lu et j\'accepte le ',
    serviceAgreement: 'Accord de service',
    confirmImport: 'Confirmer l\'importation'
  },
  tronlinkImport: {
    title: 'Importer le portefeuille',
    description:
      'Saisissez votre mnémonique, clé privée ou contenu du fichier Keystore pour restaurer ou migrer votre portefeuille. Nous ne stockons pas vos informations de clé privée.'
  },
  tronlinkWallet: {
    title: 'Importer le portefeuille',
    placeholder: 'Saisissez la mnémonique ou la clé privée'
  },
  metamask: {
    importTitle: 'Importer le portefeuille',
    subTitle: 'Saisissez votre phrase de récupération ici',
    placeholder: 'Séparez chaque mot par un espace et assurez-vous que personne regarde.',
    wordHint: 'Utilisez uniquement des minuscules, vérifiez l\'orthographe et conservez l\'ordre original des mots.',
    continue: 'Continuer',
    sheetTitle: 'Qu\'est-ce qu\'une phrase de récupération secrète ?',
    sheetP1:
      'Une phrase de récupération secrète (également appelée mnémonique) est un ensemble de mots qui vous permet d\'accéder et de contrôler votre portefeuille crypto. Vous en avez besoin pour migrer votre portefeuille vers MetaMask.',
    sheetListTitle: 'Toute personne ayant votre phrase de récupération secrète peut :',
    sheetL1: 'Prendre tous vos fonds',
    sheetL2: 'Confirmer des transactions',
    sheetL3: 'Modifier vos informations de connexion',
    gotIt: 'Compris'
  },
  trust: {
    headerTitle: 'Portefeuille multi-crypto',
    walletName: 'Nom du portefeuille',
    defaultWalletName: 'Portefeuille principal 1',
    mnemonicLabel: 'Phrase de récupération',
    tips: 'Généralement 12 mots (parfois 18 ou 24), séparés par un seul espace',
    invalidMnemonic: 'Phrase de récupération invalide'
  },
  okx: {
    title: 'Saisissez la phrase de récupération ou la clé privée',
    placeholder: 'Si vous importez avec une phrase de récupération, séparez chaque mot par un espace'
  }
};
